import { type Maybe } from '@adornis/base/utilTypes.js';
import { Appointment } from '@adornis/buchungsheld-db/entities/appointment.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import type { DialogOptions } from '@adornis/dialog/x-plain-dialog.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { type DateTime } from 'luxon';
import { filter } from 'rxjs';

@customElement('bh-prompt-ikh-export-payments')
export class BHPromptIkhExportPayments extends TrDialog<Maybe<Appointment>> {
  @property({ attribute: false }) appointment = new RXController<Maybe<Appointment>>(this, new Appointment({}));

  @state() private readonly _form = new FormController(this, this.appointment.observable.pipe(filter(Boolean)), {
    success: async doc => {
      return this.close(doc);
    },
    error: err => {
      console.log(err);
    },
  });

  override async cancel(returnVal?: any): Promise<void> {
    await this.close(null);
  }

  static override get element_name() {
    return 'bh-prompt-ikh-export-payments';
  }

  override render() {
    if (!this._form.document) return html` <x-loading-state></x-loading-state> `;

    return html`
      <x-flex space="md">
        <x-h2>${this._translation.translate('imp_exp', 'exp_intern_payments')}</x-h2>

        <x-date-picker-dropdown show-time placeholder="Von" ${this._form.field('start')}></x-date-picker-dropdown>

        <x-date-picker-dropdown
          show-time
          placeholder="Bis"
          ${this._form.field('end')}
          .isDateBlocked=${(date: DateTime) => {
            if (!this._form.document?.start) return false;
            return date <= this._form.document.start && !date.hasSame(this._form.document.start, 'day');
          }}
        ></x-date-picker-dropdown>

        <x-flex horizontal space="md">
          <x-button @click=${() => this._form.validate()}>${this._translation.translate('export')}</x-button>
          <x-button @click=${() => this.cancel()}>${this._translation.translate('discard')}</x-button>
        </x-flex>
      </x-flex>
    `;
  }

  override getInnerWrapper(options: Required<DialogOptions>) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty('background', this.colors.white);
    wrapperElem.style.setProperty('border-radius', this.sizes.borderRadius);
    wrapperElem.style.setProperty('width', `min(550px, 95%)`);
    wrapperElem.style.setProperty('padding', this.spacing.lg);
    return wrapperElem;
  }
}
